import store from '@/store/BookingStore'
import { BookingFunnelService } from '@/service/BookingFunnelService/BookingFunnelService'
import { Booking } from '../../../../requests-module'

export async function saveContactForLoggedUser(): Promise<void> {
    const email = store.getters.getLoggedUser?.email
    const token = store.getters.getToken
    if (!email || !token) return

    try {
        const response = await BookingFunnelService.setContact(email)
        if (response && !('error' in response)) {
            store.commit('setBooking', response as Booking)
        }
    } catch (err) {
        console.error('[saveContactForLoggedUser] failed to save contact', err)
    }
}
